var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-footer"},[_c('div',{staticClass:"powered-by-shopgenie-wrapper"},[_c('span',{staticClass:"text"},[_vm._v("Powered by")]),_c('shopgenie-logo-svg')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }